import { IconForward } from '@belong/icons';
import { Link, Text } from '@belong/ui';
import css from 'src/components/view-all-reviews/view-all-reviews.module.css';
import { REVIEWS_URLS } from 'src/features/reviews/reviews.urls';

const LABEL = 'View All Reviews';

/**
 * The way out of a landing page's ratings row and into the reviews themselves.
 *
 * The row above it quotes five scores and links to none of them; this is the
 * page saying the reviews behind those numbers are readable in one place. It
 * lives beside the ratings rather than inside them because three landing pages
 * render that component and all three want the same door.
 *
 * A green text button, the style `/reviews` uses for both of its own calls to
 * action, with the arrow nudging every few seconds — see `.arrow` for why it
 * is the arrow that moves and why it mostly stays still.
 *
 * `IconForward` rather than `IconRightCaret`: the caret is a chevron, and what
 * this wants is an arrow with a shaft — the shape of "→" — which is the one
 * `@belong/icons` already draws. It is on `currentColor`, so it takes the
 * link's green and its hover darkening with no second rule.
 *
 * Set to 13px, near the cap height of the 16px label beside it, rather than a
 * step on the shared scale: that jumps from 10px to 15px and both look wrong
 * next to these words. `w-auto` keeps the glyph's aspect ratio from its
 * `viewBox`, which is the only way one height rule works for it.
 *
 * The nudge runs on its own, with no hover: on a landing page nobody has put a
 * pointer on this yet, and an arrow that only moves once you have found it is
 * pointing at something you have already seen.
 */
export function ViewAllReviews() {
  return (
    <div className="flex justify-center">
      <Link variant="text" buttonType="secondary" href={REVIEWS_URLS.REVIEWS}>
        <span className="gap-xs flex items-center">
          <Text variant="body" fontWeight="semibold">
            {LABEL}
          </Text>
          <IconForward
            className={`${css.arrow} h-[13px] w-auto shrink-0`}
            aria-hidden="true"
            focusable="false"
          />
        </span>
      </Link>
    </div>
  );
}
